// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2w7mv","imageUploader":"EGiftCard_imageUploader__3Boos"};